/* eslint-disable max-len, no-unused-vars */
import moment from 'moment'
import {
  exportToCsv,
  normalizeName,
} from '_utils/function'
import {
  BUYER_REFUNDED,
  BUYER_UNPAID,
  BUYER_PAID,
  BUYER_CANCELED,
  BUYER_COLLECTED,
} from '_utils/constant'

export function export1(arrayOrder) {
    const header = [
        'First Name',
        'Last Name',
        'Contact',
        'Event Name',
        'Order No',
        'Ref',
        'Quantity',
        'Item',
        'Price',
        'Shared discount',
        'Shared del',
        'Admin fee',
        'Amount',
        'Payment',
        'Status',
        'Pay together',
        'Comment',
    ]
    const statusLabel = {
        [BUYER_UNPAID]: 'UNPAID',
        [BUYER_PAID]: 'PAID',
        [BUYER_CANCELED]: 'CANCELLED',
        [BUYER_COLLECTED]: 'COLLECTED',
        [BUYER_REFUNDED]: 'REFUNDED',
    }

    const groupedOrders = arrayOrder.reduce((acc, order) => {
        let productName = order.pName
        if (order?.pPurchaseType === 'item') productName = `${order.pName} (INDIVIDUAL)`
        if (order?.pPurchaseType === 'case' && order?.pSplitCasePurchase) productName = `${order.pName} (CASE/CARTON)`

        const key = `${order.uid}_${order.eid}_${productName}_${order.pPrice}_${order.pPurchaseType}`

        if (!acc[key]) {
            acc[key] = {
                ...order,
                pName: productName,
                totalQuantity: 0,
                refs: [],
                comments: [],
            }
        }

        acc[key].totalQuantity += Number(order.pQuantity || 0)
        acc[key].refs.push(order.ref)
        if (order.comment) acc[key].comments.push(order.comment)

        return acc
    }, {})

    const combinedOrders = Object.values(groupedOrders)

    const rowsOfProduct = combinedOrders.map((product, idx) => {
        const {
            refs,
            uName = '',
            uPhone = '',
            eTitle = '',
            totalQuantity,
            buyerStatus,
            pPrice,
            discount,
            deliveryCost,
            adminCost,
            payTogether,
            comments,
            orderNo,
            pName,
        } = product

        const firstName = uName ? uName.split(' ').slice(0, 1).join(' ') : ''
        const lastName = uName ? uName.split(' ').slice(1).join(' ') : ''

        const qty = Number(totalQuantity) || 0
        const unitPrice = Number(pPrice ?? 0)
        const discShare = Number(discount) || 0
        const delShare = Number(deliveryCost) || 0
        const admin = Number(adminCost) || 0
        const lineAmount = Number(unitPrice * qty)

        const payment = statusLabel[buyerStatus] || ''
        const verified = buyerStatus === BUYER_PAID ? 'VERIFIED' : ''
        const payTog = payTogether ? 'Yes' : 'No'

        const combinedRefs = refs.join(', ')

        const combinedComments = comments.length > 0
            ? comments.join('; ').replace(/[\r\n]+/g, ' | ')
            : ''

        return [
            firstName,
            lastName,
            uPhone,
            eTitle,
            orderNo ?? (idx + 1),
            combinedRefs,
            qty,
            pName,
            `$${unitPrice}`,
            discShare,
            delShare,
            admin,
            `$${lineAmount}`,
            payment,
            verified,
            payTog,
            combinedComments,
        ]
    })

    const totalsMap = new Map()
    for (const row of rowsOfProduct) {
        const name = row[7]
        const qty = Number(row[6]) || 0
        totalsMap.set(name, (totalsMap.get(name) || 0) + qty)
    }
    const totalOrdersRows = Array.from(totalsMap.entries()).map(([name, qty]) => ({ name, qty }))

    const totalPurchase = rowsOfProduct.reduce((s, r) => {
        const price = String(r[8] || 0).replace('$', '')
        return s + Number(price) * Number(r[6] || 0)
    }, 0)
    const totalAdmin = rowsOfProduct.reduce((s, r) => s + Number(r[11] || 0), 0)
    const paymentConfirmed = rowsOfProduct.reduce((s, r) => {
        const amount = String(r[12] || 0).replace('$', '')
        return s + (r[13] === 'PAID' ? Number(amount) : 0)
    }, 0)

    const separatorRow = new Array(header.length).fill('')
    separatorRow[2] = '-------------'
    separatorRow[10] = '---------------------'

    const TOTAL_ORDERS_INDENT = 1
    const INDENT_CHAR = ''

    const sectionTitleRow = new Array(header.length).fill('')
    sectionTitleRow[2] = 'Total orders'
    sectionTitleRow[10] = 'Payment Summary'

    const rightSummaryPairs = [
        ['Total Purchase', `$${totalPurchase}`],
        ['Admin Fee', `$${totalAdmin}`],
        ['Payment Confirmed', `$${paymentConfirmed}`],
    ]
    const maxLen = Math.max(totalOrdersRows.length, rightSummaryPairs.length)
    const mergedSectionRows = []
    for (let i = 0; i < maxLen; i++) {
        const r = new Array(header.length).fill('')

        if (i < totalOrdersRows.length) {
            for (let c = 0; c < TOTAL_ORDERS_INDENT; c++) r[c] = INDENT_CHAR
            r[TOTAL_ORDERS_INDENT + 1] = totalOrdersRows[i].name
            r[TOTAL_ORDERS_INDENT + 2] = totalOrdersRows[i].qty
        }

        if (i < rightSummaryPairs.length) {
            r[10] = rightSummaryPairs[i][0]
            r[11] = rightSummaryPairs[i][1]
        }

        mergedSectionRows.push(r)
    }
    const rows = [
        header,
        ...rowsOfProduct,
        [''],
        separatorRow,
        sectionTitleRow,
        ...mergedSectionRows,
    ]

    const fileName = normalizeName(`manage orders by ${moment().format('DD-MM-YYYY')}`)
    exportToCsv(`${fileName}.csv`, rows)
}
